import React from 'react';

const TrashOutlined = ({ color = '#424242', width = 20, height = 20, ...rest }) => {
  return (
    <svg {...rest} height={height} width={width} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none">
      <path
        d="M13 3.66146L12.5867 10.3448C12.4813 12.0521 12.4287 12.9061 12 13.5201C11.7884 13.8236 11.5159 14.0797 11.2 14.2721C10.562 14.6615 9.70667 14.6615 7.996 14.6615C6.28267 14.6615 5.426 14.6615 4.78667 14.2715C4.47059 14.0786 4.19814 13.8221 3.98667 13.5181C3.55867 12.9035 3.50667 12.0481 3.404 10.3381L3 3.66146M2 3.66146H14M10.704 3.66146L10.2487 2.72279C9.94667 2.09879 9.79533 1.78746 9.53467 1.59279C9.47676 1.54967 9.41545 1.51132 9.35133 1.47812C9.06267 1.32812 8.716 1.32812 8.02333 1.32812C7.31267 1.32812 6.95733 1.32812 6.66333 1.48412C6.59834 1.51893 6.53635 1.55907 6.478 1.60413C6.21467 1.80613 6.06733 2.12946 5.77267 2.77546L5.36867 3.66146"
        stroke={color}
        stroke-width="1.08281"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default TrashOutlined;
